import type { AnlageStatus, DokumentTyp, ExtraktionsStatus, MastrStatus, NetzbetreiberStatus } from "../api/typen";

const zahl = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 });
const datumFormat = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
const zeitFormat = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
});

export function kwp(wert: number | null | undefined): string {
  return wert === null || wert === undefined ? "–" : `${zahl.format(wert)} kWp`;
}

export function datum(iso: string | null | undefined): string {
  if (!iso) return "–";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return Number.isNaN(d.getTime()) ? iso : datumFormat.format(d);
}

export function zeitpunkt(iso: string | null | undefined): string {
  if (!iso) return "–";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : zeitFormat.format(d);
}

export function dateigroesse(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${zahl.format(bytes / 1024)} KB`;
  return `${zahl.format(bytes / 1024 / 1024)} MB`;
}

export const STATUS_TEXT: Record<AnlageStatus, string> = {
  draft: "Entwurf",
  validiert: "Validiert",
  final: "Final",
  angemeldet: "Angemeldet",
};

export const MASTR_STATUS_TEXT: Record<MastrStatus, string> = {
  nicht_begonnen: "Nicht begonnen",
  in_bearbeitung: "In Bearbeitung",
  registriert: "Registriert",
};

export const NETZBETREIBER_STATUS_TEXT: Record<NetzbetreiberStatus, string> = {
  nicht_begonnen: "Nicht begonnen",
  eingereicht: "Eingereicht",
  bestaetigt: "Bestätigt",
};

export const TYP_TEXT: Record<DokumentTyp, string> = {
  rechnung: "Rechnung",
  formular: "Formular",
  vollmacht: "Vollmacht",
  foto: "Foto",
};

export const TYP_ICON: Record<DokumentTyp, string> = {
  rechnung: "📄",
  formular: "📋",
  vollmacht: "✍️",
  foto: "📸",
};

export const EXTRAKTION_TEXT: Record<ExtraktionsStatus, string> = {
  ausstehend: "Ausstehend",
  erfolgreich: "Extrahiert",
  fehlgeschlagen: "Fehlgeschlagen",
  nicht_erforderlich: "Nur gespeichert",
};
